import React from 'react';
import styled from 'styled-components/macro';
import classNames from 'classnames';
import { Link } from 'react-navi';

const Root = styled.nav`
  .navbar-item img {
    height: 100px;
    max-height: none;
  }

  .navbar .container {
    display: flex;
    align-items: center;
  }

  .navbar-item {
    &:hover {
      background-color: transparent !important;
    }
  }

  .navbar-menu {
    background-color: transparent !important;
    box-shadow: none;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .navbar-end {
    justify-content: flex-end;
    margin-left: auto;
    display: flex;
    align-items: center;
    max-height: 70px;
  }

  @media screen and (max-width: 769px) {
    .navbar-item img {
      height: 70px;
    }
    .navbar-item.buttons {
      margin-top: 1.5rem;
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-end;
      .button {
        margin-right:0;
      }
     
    }
    .navbar-end {
      max-height: 6Navba0px;
    }
`;

export interface NavBarProps {
  logoImageSrc: string;
  entryUrl?: string;
  finished?: boolean;
}

export function NavBar(props: NavBarProps) {
  return (
    <Root className="navbar">
      <div className="container is-flex">
        <div className="navbar-brand">
          <Link className="navbar-item" href="/">
            <img src={props.logoImageSrc} />
          </Link>
        </div>
        <div className="navbar-end">
          <a className="navbar-item is-hidden-mobile has-text-weight-bold" href="/#about">
            コンテスト概要
          </a>
          <a className="navbar-item is-hidden-mobile has-text-weight-bold" href="/#history">
            昨年の様子
          </a>
          <a className="navbar-item is-hidden-mobile has-text-weight-bold" href="/#news">
            最新情報
          </a>
          <div className="navbar-item buttons">
            <Link className={classNames("button is-small-mobile is-primary has-text-weight-bold")} href="/final">
              ファイナリスト
            </Link>
            <Link className="button is-gold is-small-mobile has-text-weight-bold" href="/#award">
              受賞者一覧
            </Link>
          </div>
        </div>
      </div>
    </Root>
  );
}
